import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { BiddingTypes } from 'store/modules/monitoring_store/types';
import BiddingDate from 'components/atoms/bidding_date';
import { BiddingStatus } from './styles';

interface MonitoringInfoBiddingModalProps {
  modalMonitoringInfoBiddingOpened: boolean;
  setModalMonitoringInfoBiddingOpened: React.Dispatch<React.SetStateAction<boolean>>;
  bidding: BiddingTypes;
}

const MonitoringInfoBiddingModal = (props: MonitoringInfoBiddingModalProps) => {
  const { modalMonitoringInfoBiddingOpened, setModalMonitoringInfoBiddingOpened, bidding } = props;

  return (
    <Modal show={modalMonitoringInfoBiddingOpened} size="lg">
      <div className="modal-header">
        <h5 className="modal-title" id="staticBackdropLabel">
          Detalhes da licitação
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => setModalMonitoringInfoBiddingOpened(false)}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        <div className="row mb-3">
          <div className="col-12">
            <div className="font-weight-bold">Objeto:</div>
            <div dangerouslySetInnerHTML={{ __html: bidding?.objeto || '-' }} />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <div className="font-weight-bold">Datas:</div>
            {!bidding?.datahora_abertura &&
              !bidding?.datahora_prazo &&
              !bidding?.datahora_documento &&
              !bidding?.datahora_retirada &&
              !bidding?.datahora_visita &&
              'Não Informadas'}
            {bidding?.datahora_abertura && (
              <BiddingDate date={bidding?.datahora_abertura} dateType="Abertura" />
            )}
            {bidding?.datahora_prazo && (
              <BiddingDate date={bidding?.datahora_prazo} dateType="Prazo" />
            )}
            {bidding?.datahora_documento && (
              <BiddingDate date={bidding?.datahora_documento} dateType="Documento" />
            )}
            {bidding?.datahora_retirada && (
              <BiddingDate date={bidding?.datahora_retirada} dateType="Retirada" />
            )}
            {bidding?.datahora_visita && (
              <BiddingDate date={bidding?.datahora_visita} dateType="Visita" />
            )}
          </div>
          <div className="col-6">
            <div className="font-weight-bold">Situação:</div>
            <BiddingStatus>
              <span
                className={`bidding-situation-${bidding?.bidding_grouping?.descricao?.replace(
                  /\s/g,
                  '-',
                )}`.toLowerCase()}
                dangerouslySetInnerHTML={{ __html: bidding?.bidding_grouping.descricao || '-' }}
              />
            </BiddingStatus>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <div className="font-weight-bold">Edital:</div>
            <div>{bidding?.edital}</div>
          </div>

          <div className="col-6">
            <div className="font-weight-bold">Nº Conlicitação:</div>
            <div>
              <a href={`/biddings/${bidding?.id}`} target="_blank" rel="noreferrer">
                {bidding?.id}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          data-dismiss="modal"
          onClick={() => setModalMonitoringInfoBiddingOpened(false)}
        >
          Fechar
        </button>
      </div>
    </Modal>
  );
};

export default MonitoringInfoBiddingModal;
